<template>
    <nuxt-link 
        :to="$prismic.linkResolver(card)"
        class="review-container"
    >
        <div class="review-header">
            <prismic-image 
                :img="card.data.card_image"
                :alt="card.data.title"
                w="100"
            />
            <div class="name-and-rating">
                <span class="name">
                    {{ review.rater_name }}
                </span>
                <stars 
                    class="rating"
                    :rating="review.rating_score"
                    :show-in-norway="true"
                />
            </div>
        </div>
        <div 
            class="review-text rich-text"
            v-html="$format.comment(review.rating_body)"
        />
        <div class="review-footer">
            <div class="review-date">
                <i class="far fa-calendar" />
                <span class="date">
                    {{ $format.date(review.posted_at) }}
                </span>
            </div>
            <span class="read-more"> 
                {{ $translate('cta_read_more', 'Läs mer') }}
                <i class="fas fa-arrow-right" />
            </span>
        </div>
    </nuxt-link>
</template>

<script>
import Stars from '@/components/stars/Stars.vue';
export default {
    components: {
        Stars
    },
    props: {
        review: {
            type: Object,
            required: true
        }
    },
    computed: {
        card() {
            return this.$store.state.cards[this.review.card_id];
        }
    }
};
</script>
<style lang="scss" scoped>
.review-container::v-deep {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: $font;
    @include spacing(padding, 4);
    box-shadow: 0 0.375rem 1.5rem 0 rgba(140, 152, 164, .125);
    @include border-radius(5px);

    &:hover {
        .read-more {
            color: $red;
        }
    }

    .review-header {
        display: flex;
        align-items: center;
        gap: 1rem;

        .name-and-rating{
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .name {
                font-family: $fontHeader;
                font-weight: bold;
            }
            .rating {
                i { font-size: 18px; }
            }
        }
    }

    .review-text {
        flex-grow: 1;
        display: -webkit-box;
        line-clamp: 3;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

        :first-child {
            margin: 0;
        }
    }

    .review-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 1rem;
        font-family: $fontText;

        .review-date {
            .date {
                opacity: .5;
                font-size: 14px;
            }
            i {
                color: $red;
            }
        }

        .read-more {
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
    }
}
</style>